module.exports = __webpack_public_path__ + "img/reddit.dbe26c16.svg";